import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentCanGoOutAlone(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.canGoOutAlone.url, { id }))
    .get<boolean>()
}
